module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Hoshi Labs","short_name":"Hoshi Labs","description":"Indie game studio in Japan","start_url":"/","lang":"ja","background_color":"#120F2B","theme_color":"#120F2B","display":"minimal-ui","icon":"src/images/hoshi-labs-icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"3d99abcd8436ad140d1fa54df37acdef"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
